import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { MealDateRow } from "./meal-date-row.js";
import { AreMonthsEqual, IsDateInPast, IsoDateFormatter } from "../lib/date-utilities.js";

MealDateRow.Register();

const INITIAL_DATE_COUNT = 14;
const MAX_INITIAL_DATE_COUNT = 16;

export class CalendarList extends UnshadowedElement {
    static elementName() { return "calendar-list" }

    static properties = {
        // All dates ever for the train, past and future. Array of nAccessibleEntity<nMealTrainDate>
        dates: { type: Array },
        // Show past dates vs future
        past: { type: Boolean },
        // Show all dates vs just first n
        expanded: { type: Boolean },
    };

    render() {
        if (!this.dates) return html`Loading`;

        let filtered;
        if (this.past) {
            // Past only
            filtered = this.dates.filter(item => IsDateInPast(item.Entity.Date));
        } else {
            // Future only
            filtered = this.dates.filter(item => !IsDateInPast(item.Entity.Date));
        }
        const nodes = [];
        // If showing future, and there are past dates, show a link for the modal
        if (!this.past && filtered.length < this.dates.length) {
            nodes.push(html`<a data-bs-toggle="modal" data-bs-target="#modalPastDates" class="train-calendar__view-past-dates-button button button-link underline no-padding">View Past Dates</a>`);
        }

        // If we have dates, show them
        if (filtered.length) {
            /** Maximum number of dates to show */
            let max = filtered.length;
            if (!this.expanded && filtered.length > MAX_INITIAL_DATE_COUNT) {
                max = INITIAL_DATE_COUNT;
            }
            // Show all date rows, with month dividers if needed
            for (let i = 0; i < max; i++) {
                if (i === 0 || !AreMonthsEqual(filtered[i].Entity.Date, filtered[i - 1].Entity.Date)) {
                    nodes.push(html`<div class="alert alert-info calendar-list__divider">${IsoDateFormatter.LongMonthYear(filtered[i].Entity.Date)}</div>`);
                }
                nodes.push(html`<meal-date-row .trainDate=${filtered[i]}></meal-date-row>`);
            }

            // If there are remaining dates, show expander button
            const remaining = filtered.length - max;
            if (remaining > 0) {
                nodes.push(html`<button @click=${() => { this.expanded = true }} class="train-calendar__view-more-dates-button button button-link underline no-padding">Show ${remaining} More ${remaining === 1 ? "Date" : "Dates"}</button>`);
            }
        } else {
            // No dates, show one of many "no dates" messages
            // Here we can assume we are in "past = false" mode since we never show the past dates modal if there are none

            const emptynodes = [];
            /** Have there been any past dates */
            const hasPast = (filtered.length < this.dates.length);
            if (hasPast) {
                // There are past dates
                emptynodes.push(html`<p class="font:label-m">No upcoming dates</p>`);
            } else {
                emptynodes.push(html`<p class="font:label-m">No dates added</p>`);
            }
            if (window.CurrentTrain.IsAdmin) {
                emptynodes.push(html`<p class="color:muted-blue"><a href="/trains/${window.CurrentTrain.Id}/calendar">Add dates</a> to the calendar.</p>`);
            } else {
                // There are past dates
                if (window.CurrentTrain.ShowDonations) {
                    emptynodes.push(html`<p class="color:muted-blue">Please <a href="/trains/${window.CurrentTrain.Id}/message/${window.CurrentTrain.OrganizerId}">contact the organizer</a> to request ${hasPast ? "more " : ""}dates, or <a id="lnk-donate-empty-calendar" data-wireup-click-tracking href="${window.CurrentTrain.OpenUrl}/donate/init">make a donation</a> to ${window.CurrentTrain.Name}.</p>`);
                } else if (window.CurrentTrain.ShowGiftCards) {
                    emptynodes.push(html`<p class="color:muted-blue">Please <a href="/trains/${window.CurrentTrain.Id}/message/${window.CurrentTrain.OrganizerId}">contact the organizer</a> to request ${hasPast ? "more " : ""}dates, or <a id="lnk-giftcard-empty-calendar" data-wireup-click-tracking data-bs-toggle="modal" data-bs-target="#modalGiftCardPicker">send a gift card</a> to ${window.CurrentTrain.Name}.</p>`);
                } else {
                    emptynodes.push(html`<p class="color:muted-blue">Please <a href="/trains/${window.CurrentTrain.Id}/message/${window.CurrentTrain.OrganizerId}">contact the organizer</a> to request ${hasPast ? "more " : ""}dates.</p>`);
                }
            }
            // Wrap up the whole "no dates" message and dump to nodes
            nodes.push(html`
                <div class="train-calendar__empty">
                    <img src="/content/img/illustration/empty-calendar.svg">
                    ${emptynodes}
                </div>
            `);
        }

        return html`${nodes}`;
    }
}
